const combineNullableStrings = (...arguments_)=>arguments_.filter(Boolean).join(' ') || void 0;
export { combineNullableStrings };
